import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const MaleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      <path
        d="M15.375 31.6875V22.5H13.6875C13.3125 22.5 13 22.375 12.75 22.125C12.5 21.875 12.375 21.5625 12.375 21.1875V13.2375C12.375 12.5375 12.625 11.925 13.125 11.4C13.65 10.875 14.275 10.6125 15 10.6125H21C21.725 10.6125 22.3375 10.875 22.8375 11.4C23.3625 11.925 23.625 12.5375 23.625 13.2375V21.1875C23.625 21.5625 23.5 21.875 23.25 22.125C23 22.375 22.6875 22.5 22.3125 22.5H20.625V31.6875C20.625 32.0625 20.5 32.375 20.25 32.625C20 32.875 19.6875 33 19.3125 33H16.6875C16.3125 33 16 32.875 15.75 32.625C15.5 32.375 15.375 32.0625 15.375 31.6875ZM18 8.7375C17.225 8.7375 16.55 8.4625 15.975 7.9125C15.425 7.3375 15.15 6.6625 15.15 5.8875C15.15 5.0875 15.425 4.4125 15.975 3.8625C16.525 3.2875 17.2 3 18 3C18.8 3 19.475 3.2875 20.025 3.8625C20.6 4.4125 20.8875 5.075 20.8875 5.85C20.8875 6.65 20.6 7.3375 20.025 7.9125C19.475 8.4625 18.8 8.7375 18 8.7375Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
